import React from "react";

import Section from "../../ui/components/Section/Section";

import { useProfile } from "../../authentication/state/profile";
import SuperAdminDashboard from "../../dashboard/components/Dashboard/SuperAdminDashboard";

import AlertsWidget from "../components/AlertsWidget/AlertsWidget";
import FavoriteProductionsWidget from "../components/FavoriteProductionsWidget/FavoriteProductionsWidget";
import MyProductionsWidget from "../components/MyProductionsWidget/MyProductionsWidget";
import NotificationsWidget from "../components/NotificationsWidget/NotificationsWidget";
import TodosWidget from "../components/TodosWidget/TodosWidget";
import HomeLayout from "../layouts/HomeLayout/HomeLayout";

export default function HomeSuperAdminView() {
	const user = useProfile();

	return (
		<>
			<Section>
				<SuperAdminDashboard />
			</Section>

			<Section>
				<HomeLayout>
					<HomeLayout.LeftColumn>
						<NotificationsWidget userId={user.id} />
						<TodosWidget userId={user.id} />
					</HomeLayout.LeftColumn>

					<HomeLayout.RightColumn>
						<AlertsWidget userId={user.id} />
						<FavoriteProductionsWidget userId={user.id} />
						<MyProductionsWidget userId={user.id} />
					</HomeLayout.RightColumn>
				</HomeLayout>
			</Section>
		</>
	);
}
